<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header flex justify-content-between">
        <h5>На руках у старших курьеров</h5>
        <div class="flex">
          <div>
            <DateSelect
              ref="selectedDate"
              :onSelect="showReport"
              :selectedDate="selectedDate"
            />
          </div>
          <vue-ladda
            @click="showReport()"
            button-class="btn btn-success"
            data-style="zoom-in"
            :loading="loading"
          >Показать
          </vue-ladda>
        </div>
      </div>
      <div class="card-body" v-if="showDivBalances">
        <!--        <CustomPulseLoader :loading="loading"/>-->
        <DateBalance
          :setDate="$refs.selectedDate.date"
        />

        <div v-if="false && !loading && Object.keys(balance).length">
          <table class="table table-sm table-hover">
            <thead>
            <tr>
              <th>Курьер</th>
              <th>RUB</th>
              <th>EUR</th>
              <th>USD</th>
              <th>Итого в EUR</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="division in mixinGetSortedDivisions()" :key="division.id">
              <td>
                <p class="division_runner">
                  ({{ division.id }}) {{ division.user && division.user.short_name || 'Не привязан' }}
                  ({{ division.user && division.user.id }})
                </p>
                <div class="text-muted">
                    <span
                      class="d_info"
                      v-for="store in division.stores"
                      :key="`store_${store.id}`"
                    >
                      {{ $AllStores[store.object_id].short_title }}
                    </span>
                  /
                  <span
                    v-for="(city, index) in division.cities"
                    :key="`city_${city.id}`"
                  >{{
                      index > 0 ? ", " : ""
                    }}{{ $AllCities[city.object_id].name }}</span
                  >
                </div>
              </td>
              <td>
                {{
                  (balance[division.id] &&
                    balance[division.id].balance &&
                    balance[division.id].balance[33] &&
                    balance[division.id].balance[33].orders.toLocaleString(
                      "ru-RU"
                    )) ||
                  0
                }}
              </td>
              <td>
                {{
                  (balance[division.id] &&
                    balance[division.id].balance &&
                    balance[division.id].balance[28] &&
                    balance[division.id].balance[28].orders.toLocaleString(
                      "ru-RU"
                    )) ||
                  0
                }}
              </td>
              <td>
                {{
                  (balance[division.id] &&
                    balance[division.id].balance &&
                    balance[division.id].balance[34] &&
                    balance[division.id].balance[34].orders.toLocaleString(
                      "ru-RU"
                    )) ||
                  0
                }}
              </td>
              <td>
                {{
                  totalFigures.byDivision[division.id].toLocaleString("ru-RU")
                }}
              </td>
            </tr>
            <tr class="result_tr">
              <td>ИТОГО</td>
              <td>{{ totalFigures[33].toLocaleString("ru-RU") }}</td>
              <td>{{ totalFigures[28].toLocaleString("ru-RU") }}</td>
              <td>{{ totalFigures[34].toLocaleString("ru-RU") }}</td>
              <td>{{ totalFigures.grand.toLocaleString("ru-RU") }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header flex justify-content-between">
        <h5 class="flex-grow-1">Провести групповую инкассацию</h5>
        <button @click="showGroupIncashment = !showGroupIncashment" class="btn btn-default">
          {{ showGroupIncashment ? 'свернуть' : 'открыть' }}
        </button>
      </div>
      <div class="card-body" v-if="showGroupIncashment">
        <MultiIncashment/>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h5>Список инкассаций</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-9">
            <div class="form-group">
              <label for="">Старшие курьеры</label>
              <multiselect
                v-model="selectedDivisions"
                :options="divisionsForSelect"
                @input="updateSelected"
                :multiple="true"
                label="name"
                track-by="value"
                placeholder="Выберите курьера"
                select-label="Выбрать"
                deselect-label="Удалить курьера"
              />
            </div>
            <div v-if="!selectedDivisionsIds.includes(0)">
              <div class="form-check">
                <input class="form-check-input" type="radio" id="r_1" value="all" v-model="filter">
                <label class="form-check-label" for="r_1">все инкассации</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" id="r_2" value="income" v-model="filter">
                <label class="form-check-label" for="r_2">только входящие</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" id="r_3" value="outcome" v-model="filter">
                <label class="form-check-label" for="r_3">только исходящие</label>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="">за последние дней</label>
              <input
                @change="() => getIncomes()"
                type="number"
                v-model="incomeDays"
                class="form-control"
              />
            </div>
            <div class="text-right">
              <vue-ladda
                v-if="incomes && incomes.length"
                @click="() => getIncomes(true)"
                button-class="btn btn-outline-primary"
                data-style="zoom-in"
                :loading="loadingIncomes"
              >Экспорт в XLS
              </vue-ladda>
              <vue-ladda
                @click="() => getIncomes()"
                button-class="btn btn-success"
                data-style="zoom-in"
                :loading="loadingIncomes"
              >Загрузить
              </vue-ladda>
            </div>
          </div>
        </div>
        <CustomPulseLoader :loading="loadingIncomes"/>
        <div class="p-t-10">
          <table class="table table-sm table-hover" v-if="incomes.length">
            <thead>
            <tr>
              <th>Источник</th>
              <th>Направление</th>
              <th>Сумма</th>
              <th>Валюта</th>
              <th>Отчет/Создание</th>
              <th>Транзакция</th>
              <th>Комментарий</th>
              <th>Получатель</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="record in incomes" :key="record.id">
              <td>
                <template v-if="record.incomes?.length">
                  <p v-for="i in record.incomes"><strong>{{ i.sum }}</strong>
                    {{ $AllCurrencies[i.currency_id].currency }} : {{ $AllDivisions[i.division_id]?.title }}</p>
                </template>
                <template v-if="record.type_id === 3">
                  <strong>{{ $platformConstants.nonCashResources[record.source_id]?.title }}</strong>
                </template>
                <template v-else>
                  <strong>{{ $AllDivisions[record.division_id] && $AllDivisions[record.division_id].title }}</strong>
                  ({{
                    $AllDivisions[record.division_id]?.user?.short_name ?? $AllDivisions[record.division_id]?.user?.name ?? record.division_id
                  }})
                </template>
              </td>
              <td>
                <div v-html="getCashoutDirections(record)"/>
              </td>
              <td><strong>{{ record.sum.toLocaleString("ru-RU") }}</strong></td>
              <td>
                {{
                  ($AllCurrencies[record.currency_id] &&
                    $AllCurrencies[record.currency_id].currency) ||
                  record.currency_id
                }}
              </td>
              <td>
                {{ printDate(record.report_date, 'DD.MM.YYYY HH:mm') }}<br/>
                {{ printDate(record.created_at, 'DD.MM.YYYY HH:mm') }}
              </td>
              <td>
                <div v-if="record.data?.by_trader">
                  <p><strong>{{ record.data.converted_sum ?? record.sum }}</strong> * {{ record.data.rate }}</p>
                  <p><span v-if="record.data.group_transaction" class="badge badge-info">group</span>
                    <template v-if="record?.data?.send_address || record?.data?.receive_address">
                      {{
                        (record?.data?.send_address ?? '').length > 10 ? record.data.send_address.substring(0, 8) + '...' : record.data.send_address
                      }} : {{
                        (record?.data?.receive_address ?? '').length > 10 ? record.data.receive_address.substring(0, 8) + '...' : record.data.receive_address
                      }}
                    </template>
                    <span v-if="record.data.aml_risk">(<strong>{{
                        record.data.aml_risk
                      }}%</strong>)</span></p>
                </div>
              </td>
              <td>{{ record.comment }}</td>
              <td>
                {{
                  ($AllDivisions[record.to_division_id] &&
                    $AllDivisions[record.to_division_id].user.name) ||
                  record.to_division_id ||
                  "Администрация"
                }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import CustomPulseLoader from "@/components/loaders/CustomPulseLoader.vue";
import VueLadda from "vue-ladda/src/vue-ladda.vue";
import DateSelect from "./components/DateSelect.vue";
import Multiselect from "vue-multiselect";
import DateBalance from "@/components/divisions/DateBalance.vue";
import MultiIncashment from "@/views/reports/components/MultiIncashment.vue";

export default {
  title: "Касса",
  components: {MultiIncashment, DateBalance, CustomPulseLoader, VueLadda, DateSelect, Multiselect},
  data() {
    return {
      loading: false,
      showGroupIncashment: false,
      showDivBalances: false,
      loadingIncomes: false,
      incomeDays: 100,
      divisions: {},
      balance: {},
      totalFigures: {},
      selectedDivisions: [],
      selectedDivisionsIds: [],
      divisionsForSelect: [],
      selectedDate: new Date(),
      filter: 'all',
      incomes: [],
      allIncomes: [],
    };
  },
  computed: {
    $AllCities() {
      let cities = this.$store.getters["platform/cities"];
      cities[0] = {id: 0, name: "Почтовые города", short_name: "Почта"};
      return cities;
    },
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
    $AllDivisions() {
      return this.$store.getters["platform/divisions"];
    },
    $AllStores() {
      return this.$store.getters["platform/stores"];
    },
  },
  watch: {
    'filter': {
      handler: function (val, oldVal) {
        this.updateRecordsByFilter();
      },
    },
  },
  mounted() {
    // this.getDivisions();
    const divisions = [
      {name: "Все главные курьеры", value: 0}
    ];
    Object.values(this.$AllDivisions).forEach((d) => {
      if ([1, 4, 7].includes(+d.id)) {
        divisions.push({
          name: d.title + ' | ' + (d.user && d.user.short_name || 'Не привязан'),
          value: d.id
        })
      }
    });
    const regions = Object.keys(this.$AllDivisions).reduce((acc, divId) => {
        if (![1, 4, 7].includes(+divId)) {
          acc.push({
            name: this.$AllDivisions[divId].title + ' | ' + (this.$AllDivisions[divId].user && this.$AllDivisions[divId].user.short_name || 'Не привязан'),
            value: divId
          });
        }
        return acc;
      },
      []);
    this.divisionsForSelect = [...divisions, ...(_.orderBy(regions, 'name'))];
    this.selectedDivisions.push(this.divisionsForSelect[0]);
    this.selectedDivisionsIds = [0];
  },
  methods: {
    getCashoutDirections(record) {
      if (this.selectedDivisions && +this.selectedDivisions[0].value === 0) return null;
      if (this.selectedDivisionsIds.includes(+record.to_division_id)) {
        return '<span class="badge badge-success">входящая</span>';
      }
      if (this.selectedDivisionsIds.includes(+record.division_id)) {
        return '<span class="badge badge-primary">исходящая</span>';
      }
      return null;
    },
    updateRecordsByFilter() {
      let allIncomes = _.orderBy(this.allIncomes, 'report_date', 'desc');
      if (this.filter === 'all') {
        allIncomes = this.allIncomes.reduce((acc, i) => {
          if (!i.parent_id) {
            acc[i.id] = i;
          }
          if (i.type_id === 2) {
            acc[i.id] = {
              ...i,
              incomes: this.allIncomes.filter((inc) => inc.parent_id === i.id)
            }
          }
          return acc;
        }, []);
        this.incomes = _.orderBy(Object.values(allIncomes), ['report_date', 'created_at'], ['desc', 'desc']);
        return;
      }
      const index = this.filter === 'income' ? 'to_division_id' : 'division_id';
      this.incomes = allIncomes.reduce((acc, r) => {
        if (this.selectedDivisionsIds.includes(+r[index])) {
          acc.push({...r});
        }
        return acc;
      }, [])
    },
    updateSelected() {
      const inserted = [...this.selectedDivisions].pop();
      if (inserted) {
        if (inserted.value === 0) {
          this.selectedDivisions = [{...this.divisionsForSelect[0]}];
        } else {
          this.selectedDivisions = this.selectedDivisions.filter(
            d => d.value !== 0
          );
        }
      } else {
        this.selectedDivisions = [{...this.divisionsForSelect[0]}];
      }
      this.selectedDivisionsIds = this.selectedDivisions.reduce((acc, d) => {
        acc.push(+d.value);
        return acc;
      }, [])
    },
    async getIncomes(exportXLS = false) {
      if (!this.incomeDays) {
        toastr["warning"]("Укажите количество дней!");
        return;
      }
      this.loadingIncomes = true;
      const {data} = await api.post("/reports/getIncomes", {
        type: "byDivisions",
        days: this.incomeDays,
        divisionIds: this.selectedDivisions.map(d => d.value),
        filter: this.filter,
        exportXLS
      });
      if (!data.success) {
        toastr["warning"](data.message || "Ошибка!");
      } else {
        if (!exportXLS) {
          this.allIncomes = data.records;
          // this.incomes = data.records;
          this.updateRecordsByFilter();
        } else {
          window.location.href = data.link;
        }
      }
      this.loadingIncomes = false;
    },
    showReport(e) {
      this.showDivBalances = false;
      setTimeout(() => {
        this.showDivBalances = true;
      }, 400)
      // const date = this.$refs.selectedDate.date;
      // if (date) {
      //   this.getDivisions(date);
      // }
    },
    async getDivisions(date = null) {
      this.loading = true;
      let params = "";
      if (date) {
        params = "?date=" + date;
      }
      const {data} = await api.index("/reports/getCashBox" + params);
      if (!data.success) {
        toastr["warning"](data.message || "Ошибка!");
      } else {
        this.divisions = data.divisions;
        this.balance = data.balance;
        const calculateTotal = new Promise((resolve, reject) => {
          const totalFigures = Object.keys(this.balance).reduce(
            (acc, divId) => {
              let sum = 0;
              acc.byDivision[divId] = 0;
              Object.keys(this.balance[divId].balance).forEach(currId => {
                const currencyId = parseInt(currId);
                if (currencyId) {
                  let total = this.balance[divId].balance[currencyId].orders;
                  acc[currencyId] += total;
                  if (currencyId !== 28) {
                    total *=
                      (data.rates[currencyId].rateRecord &&
                        data.rates[currencyId].rateRecord.rate) ||
                      data.rates[currencyId].rate;
                  }
                  acc.byDivision[divId] += total;
                  acc.grand += total;
                }
              });
              return acc;
            },
            {33: 0, 34: 0, 28: 0, grand: 0, byDivision: {}}
          );
          resolve(totalFigures);
        });
        this.totalFigures = await calculateTotal;
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.result_tr {
  background-color: #e5ffde;
}

p {
  margin-bottom: 2px;
}

hr {
  margin: 2px 0;
}
</style>
